export const selectedInstrumentVersionsInitialState = {
    loading: true,
    items: []
};
